import { render } from "./VocabularyExtractionDialog.vue?vue&type=template&id=f8df8634&scoped=true"
import script from "./VocabularyExtractionDialog.vue?vue&type=script&lang=js"
export * from "./VocabularyExtractionDialog.vue?vue&type=script&lang=js"

import "./VocabularyExtractionDialog.vue?vue&type=style&index=0&id=f8df8634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8df8634"]])

export default __exports__